import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isVideoAccountAndDimension } from '../../../../../config/report-predicates/isVideoAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { TOP_RESULTS_TYPE } from '../../../../../constants';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { CONTEXTUAL_VIDEO_REPORT_ID } from './contextualVideoReportId';
import graph from './graph';
import { customColumns, defaultColumns } from './reportPresets';

export const contextualVideoReportConfig = {
    id: CONTEXTUAL_VIDEO_REPORT_ID,
    label: 'Contextual',
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
    },
    permissions: [
        [REPORT_PERMISSION.ADS_CONSOLE_CONTEXTUAL_VIDEO_REPORT],
        REPORT_PERMISSION.ADS_CONSOLE_VIDEO_CAMPAIGNS,
    ],
    visibilityCondition: isVideoAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-context',
    graph,
    rowIdField: FIELDS.CONTEXT.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    sortMap: {},
    searchPlaceholderMsgId: 'app.reports.byContext.search.placeholder',
    searchField: FIELDS.CONTEXT.field,
    filters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS'],
        },
    ],
    initialFilters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            type: FILTER_TYPE.TOP_RESULTS,
            values: [{ value: TOP_RESULTS_TYPE.TOP100, label: 'Top 100', messageId: 'report.topResults.100' }],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
};

export default contextualVideoReportConfig;
